import React from 'react';
import { Row, Col, Container } from 'react-bootstrap';

const ContactUs = () => {
    return (
      <section id="contact-us">
        <Container>
          <Row>
            <Col md={6} className="rehab-txt-wrapper">
              <div className="title-txt">How Can We Help You?</div>
              <h1>Contact Rehab Find Directly</h1>
              <p>
                Want to talk with us directly so you could get personalized help
                in finding the rehabilitation care you need? <br /> Our team
                would be glad to help you out in whatever means possible. Simply
                enter your details at the form provided below and one of our
                representatives will contact you as soon as possible!
              </p>
            </Col>
            <Col md={5} className="offset-md-1">
              <form className="p-md-5 p-3 contact-form ">
                <h1 className="mb-4">Contact Us</h1>
                <input
                  type="text"
                  className="form-control mb-4 field"
                  placeholder="Full Name"
                />
                <input
                  type="Phone Number"
                  className="form-control mb-4 field"
                  placeholder="Email"
                />
                <input
                  type="email"
                  className="form-control mb-4 field"
                  placeholder="Phone"
                />
                <textarea
                  rows="4"
                  placeholder="Your Message"
                  className="pl-3"
                ></textarea>
                <button
                  className="btn btn-block ml-auto d-block "
                  type="submit"
                >
                  Send
                </button>
              </form>
            </Col>
          </Row>
        </Container>
      </section>
    )
}
 
export default ContactUs;